var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_footer_social_twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_footer_social_twitter"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(6.000000, 7.000000)",
    fill: "#FA7D05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3147144,1.11511967 C13.6801591,0.428823171 12.7732625,0 11.7692308,0 C9.84468534,0 8.28280779,1.58251898 8.28280779,3.53420268 C8.28280779,3.81141264 8.31276533,4.08009996 8.37268043,4.33891897 C5.47406082,4.1913428 2.90452033,2.78600493 1.1833231,0.645028996 C0.882839826,1.16894685 0.711264785,1.77674538 0.711264785,2.42401717 C0.711264785,3.64948255 1.3267562,4.7314088 2.26315649,5.3652238 C1.69214749,5.34817853 1.15336555,5.18759412 0.682215043,4.92473807 L0.682215043,4.96779981 C0.682215043,6.6808497 1.88460203,8.10996123 3.48143006,8.43337285 C3.18911703,8.51635641 2.88046351,8.55807247 2.56227806,8.55807247 C2.33759645,8.55807247 2.11836168,8.5365416 1.90593544,8.4952741 C2.34985181,9.89881772 3.63711852,10.9210855 5.1635917,10.9484477 C3.97028275,11.8967031 2.46559688,12.4618884 0.832002777,12.4618884 C0.550583398,12.4618884 0.272341334,12.4457403 0,12.413444 C1.54326756,13.4146295 3.37748645,14 5.3465143,14 C11.7624222,14 15.2697247,8.61548813 15.2697247,3.9446349 C15.2697247,3.79077889 15.2670013,3.63737144 15.2611006,3.48665535 C15.9424078,2.98830541 16.5342963,2.36615296 17,1.65742847 C16.3754305,1.93822691 15.7027474,2.12841626 14.9973834,2.21364263 C15.7177262,1.77674538 16.2705791,1.08416904 16.531119,0.258819006 C15.8566203,0.663419948 15.1113128,0.957675179 14.3147144,1.11511967 Z",
    id: "Twitter"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.087d6042fc5f639557bf09dfe0f116d5.svg";
export { ForwardRef as ReactComponent };